module.exports = __webpack_public_path__ + "static/media/TrojanWar.4bcb6e1d.jpg";